// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qw-c";
export var backButton = "_qw-4";
export var backIcon = "_qw-5";
export var chevronShortcut = "_qw-6";
export var container = "_qw-1";
export var editor = "_qw-8";
export var editorWrapper = "_qw-7";
export var prefix = "_qw-2";
export var searchIcon = "_qw-3";
export var suffix = "_qw-9";
export var suffixContent = "_qw-a";
export var suffixText = "_qw-b";
export var wrapper = "_qw-0";